import useSWR from 'swr';
import { CONFIG_API_URL } from 'global/config';
import { IFreeforms } from 'models';

export function usePriceVsDonations() {
  let url = `${CONFIG_API_URL}/contentful/freeforms`;
  const { data, error } = useSWR<IFreeforms>(url);

  return {
    value: data?.donationVsPrize || false,
    isLoading: !error && !data,
    isError: error,
  };
}
